import { render, staticRenderFns } from "./EventsRoot.vue?vue&type=template&id=ea88cde4&scoped=true&"
import script from "./EventsRoot.vue?vue&type=script&lang=ts&"
export * from "./EventsRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea88cde4",
  null
  
)

export default component.exports